import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  minW: ['unset', null, '460px'],
  bg: 'alpha.900',
  borderRightRadius: ['unset', null, 'lg'],
  form: {
    '.chakra-form-control': {
      '.chakra-form__label': {
        color: 'white',
        fontSize: 'xs',
      },
    },
    'a[href*="forgot-password"]': {
      color: 'gamma.300',
      fontWeight: 'bold',
      fontSize: 'xs',
    },
    'button[aria-label*="password toggle"]': {
      top: '-1px',
      color: 'gamma.300',
    },
    'input:-webkit-autofill, input:-webkit-autofill:focus': {
      transition: 'background-color 0s 600000s, color 0s 600000s',
    },
    '.chakra-form__error-message': {
      bg: 'red.600',
      boxShadow:
        '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
      borderRadius: 'base',
      p: '1',
      color: 'white',
      fontWeight: 'medium',
      fontSize: 'xs',
    },
  },
};

export const Title: CSSObject = {
  color: 'white',
  fontSize: 'md',
  fontFamily: 'Staatliches',
  fontStyle: 'normal',
  fontWeight: 'normal',
  mb: '4',
  mt: [null, null, '9'],
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};
